import { boolean, partial, union } from 'io-ts/Decoder';

import { Request as DisabledRequest } from '../../generic/pagination/disabled/Request';
import { Request as IndefiniteRequest } from '../../generic/pagination/indefinite/Request';

export const Request = partial({
	pagination: union(IndefiniteRequest, DisabledRequest),
	hideDeleted: boolean,
	forceRefresh: boolean,
});
